<template>
  <sui-page>
    <sui-page-header title="현황 조회" />
    <sui-page-contents>
      <div class="comm_title_wrap">
        <!-- 기본정보 -->
        <h4>{{ $t('MSG_TIT_DEFAULT_INFO') }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <!-- 제목 -->
            <sui-input-label :label="$t('MSG_TIT_TTL')" />
          </div>
          <div class="col-xs-11">
            <div class="comm_label">
              {{ approvalTitle }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <!-- 작성자 -->
            <sui-input-label :label="$t('MSG_TIT_DOC_CRTR')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ drafterSummary }}
            </div>
          </div>
          <div class="col-xs-1">
            <!-- 작성일시 -->
            <sui-input-label :label="$t('MSG_TIT_DRAT_DTM')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ approvalDraftDTM }}
            </div>
          </div>
        </div>
      </div>
      <div class="comm_title_wrap">
        <!-- 본문 정보 -->
        <h4>{{ $t('MSG_TIT_TBAB_INFO') }}</h4>
      </div>
      <div>
        <sui-web-editor
          ref="webEditor00010"
          class="width100"
          @loaded="onLoaded"
          :maxCharCount="maxContentsSize"
          :isViewer="false"
        />
      </div>
    </sui-page-contents>
    <!-- Page Footer -->
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <!-- 취소 -->
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onClickCancel"
        >
          {{ $t("MSG_BTN_CNCL") }}
        </sui-button>
        <!-- 적용 -->
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onClickApply"
        >
          {{ $t('MSG_BTN_APPLY') }}
        </sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CML_00010', // eslint-disable-line vue/name-property-casing
  filters: {
    /**
     * 필터~
     */
    dateformatToClient(value) {
      const result = utils.dateformatToClient(value);
      return utils.isDate(result) ? result : '-';
    },
  },
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default: null,
    },
    pageInitialData: {
      type: Object,
      required: true,
      default() {
        return {
          approvalContent: '',
          approvalUid: '',
          drafterUserInfo: '',
        };
      },
    },
  },
  data() {
    return {
      approvalTitle: '',
      approvalDraftDTM: '', // 작성일시
      drafterSummary: '',
      maxContentsSize: utils.getConfigurationValue('CFG_CMZ_APRV_CONT_LIMIT_SIZE'),
    };
  },
  mounted() {
    if (utils.getConfigurationValue('CFG_CML_CHG_APRV_CNTN') !== 'Y') {
      // '내용변겅을 허용하지 않습니다(환경설정).'
      utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), this.$t('MSG_ALT_NPMSN_APRV_CNTN'), () => {
        this.closePagePopup();
      });
    } else {
      this.setApprovalContent();
    }
  },
  created() {
  },
  methods: {
    /**
     * 세션 langId 와 displayLangId 를 비교하여 두 개의 값중 하나를 return
     */
    getDisplayText(displayLangId = '', localTextValue = '', globalTextValue = '') {
      return this.$store.getters.userInfo.langId === displayLangId ? localTextValue : globalTextValue;
    },
    /**
     * '적용' 버튼 click event handler
     */
    async onClickApply() {
      // validate approval contents
      const isValid = await this.validateApprovalContents();
      if (!isValid) return false;

      this.closePagePopup({
        isChanged: true,
        approvalContent: this.$refs.webEditor00010.getHtml(),
      });
      return true;
    },
    /**
     * '취소' 버튼 click event handler
     */
    onClickCancel() {
      this.closePagePopup('');
    },
    /**
     * 부모 페이지에서 prop으로 전달된 작성자 정보 및 본문 정보 set
     */
    setApprovalContent() {
      this.approvalTitle = this.pageInitialData.approvalTitle;
      // 작성자
      const drafter = this.pageInitialData.drafterUserInfo;
      this.drafterSummary = `${this.getDisplayText(drafter.userDisplayLanguageId, drafter.approvalUserName, drafter.approvalUserGlobalName)}(${drafter.approvalUserEmail.replace(/@.+/, '')}) / ${this.getDisplayText(drafter.userDisplayLanguageId, drafter.approvalDepartmentName, drafter.approvalDepartmentEnglishName)}`;
      this.approvalDraftDTM = this.pageInitialData.approvalDraftDTM;
      // this.$refs.webEditor00010.setContent(this.pageInitialData.approvalContent);
    },
    onLoaded() {
      this.$refs.webEditor00010.setContent(this.pageInitialData.approvalContent);
    },
    /**
     * 상신내용 확인
     * validate approval contents
     */
    validateApprovalContents() {
      return new Promise(resolve => {
        if (this.$refs.webEditor00010.getTextSize() === 0 && this.$refs.webEditor00010.getImagesInfo().length === 0) {
          // "본문 을(를) 입력해주세요."
          utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TIT_TBAB')), () => {
            resolve(false);
          });
        } else {
          resolve(true);
        }
      });
    },
  },
};
</script>
<style scoped>
</style>
